import React,{useContext} from "react";
import {themeContext} from '../../Context'

import "./Awards.css";
const Awards = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    return (
        <div className="award_container d-flex flex-wrap justify-content-between">
            <div className="award_item">
                <AwardItem year='2021 - Capgemini' text='
                    Recognized with Rising Star Award while working with client for the outstanding quality work done and making communication ease between client and our team eliminating redundant work, resulting in customer appreciation. Resolving and turning around any escalation and made significant contribution towards the project deliverables.
                ' title='Rising Star Award' darkMode={darkMode} />
            </div>

            {/* <div className="award_item">
                <AwardItem year='2021 - Capgemini' text='
                    Recognized with Rising Star Award while working with client for the outstanding quality work done and making communication ease between client and our team eliminating redundant work, resulting in customer appreciation. Resolving and turning around any escalation and made significant contribution towards the project deliverables.
                ' title='Rising Star Award' darkMode={darkMode} />
            </div>
            <div className="award_item">
                <AwardItem year='2021 - Capgemini' text='
                    Recognized with Rising Star Award while working with client for the outstanding quality work done and making communication ease between client and our team eliminating redundant work, resulting in customer appreciation. Resolving and turning around any escalation and made significant contribution towards the project deliverables.
                ' title='Rising Star Award' darkMode={darkMode} />
            </div> */}
        </div>
    )
};
const AwardItem = ({ year, title, text,darkMode }) => {
    return (
        <div className={`single_award ${darkMode?'single_award_dark':'single_award_light'}`}>
            <div className="award_year" style={{color: darkMode? '#ffffff' : '#000000'}}> {year} </div>
            <h6 className="award_title" style={{color: darkMode? '#ffffff' : '#000000'}}>
                {title} - {" "}
                <span>{text}</span>
            </h6>
        </div>
    )
}
export default Awards;